/** @format */
'use client'


import { FeatureCardProps } from '../../interfaces/common'
import React, { useEffect } from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'
import AnimatedContainer from '../../components/AnimatedContainer'
import TypingText from '../../components/TypingText'

const FeatureCard2 = ({ description, headerText }: FeatureCardProps) => {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    })
  }, [])

  return (
    <AnimatedContainer className="my-3 md:mx-6">
      <div
        className="dark:bg-black rounded-lg p-6 flex flex-col justify-center h-fit md:h-[459px]"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <h4 className="text-xl md:text-lg lg:text-[32px] leading-[37.54px] text-black dark:text-gray-300 font-medium md:font-normal">
          {/* {headerText} */}
          <TypingText text={headerText} speed={100} />
        </h4>
        <p className="mt-4 font-500 text-lg text-gray-500 dark:text-gray-300">
          {Array.isArray(description) ? (
            <ul className="list-disc list-inside mt-4 text-lg text-gray-500 dark:text-gray-300 space-y-2">
              {description.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          ) : (
            <p className="mt-4 font-500 text-lg text-gray-500 dark:text-gray-300 whitespace-pre-line">
              {description}
            </p>
          )}
        </p>
        {/* <button className="bg-black dark:bg-gray-100 border w-36 h-12 border-gray-300 dark:border-black mt-4 text-white text-center font-medium dark:text-black rounded-lg text-lg hover:bg-gray-700 dark:hover:bg-gray-300">
          {headerIcon}
        </button> */}
      </div>
    </AnimatedContainer>
  )
}

export default FeatureCard2
